import { Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { VerifyEmailComponent } from './user/verify-email/verify-email.component';
import { PasswordForgottenComponent } from './user/password-forgotten/password-forgotten.component';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';
import { UserSettingsComponent } from './user/user-settings/user-settings.component';
import { LoggedOnGuard } from './guards/logged-on.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire';


const routes: Routes = [
    {
        path: 'home',
        component: HomeComponent,
    },
    {
        path: 'dashboard',
        canActivate: [LoggedOnGuard],
        component: DashboardComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'register',
        component: RegisterComponent,
    },
    {
        path: 'questionnaire/:projectId/new',
        canActivate: [LoggedOnGuard],
        component: QuestionnaireComponent,
    },
    {
        path: 'questionnaire/:id/edit',
        component: QuestionnaireComponent,
        canActivate: [LoggedOnGuard],
        canDeactivate: [
            (component: QuestionnaireComponent) => component.canDeactivate()
        ],
    },
    {
        path: 'confirm-email/:key',
        component: VerifyEmailComponent,
    },
    {
        path: 'password-forgotten',
        component: PasswordForgottenComponent
    },
    {
        path: 'reset-password/:uid/:token',
        component: ResetPasswordComponent
    },
    {
        path: 'user-settings',
        canActivate: [LoggedOnGuard],
        component: UserSettingsComponent
    },

    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    }
];

export { routes };
